export const ROOM_NAME_MAX_CHARS = 10
export const ROOM_NAME_MAX_CHARS_MESSAGE =
  "O nome da sala pode conter no máximo 10 caracteres."

export function normalizeRoomName(room) {
  return String(room || "").trim()
}

export function validateRoomName(room) {
  const normalizedRoom = normalizeRoomName(room)

  if (!normalizedRoom) {
    return "Por favor, preencha o nome da Sala"
  }

  if (normalizedRoom.length > ROOM_NAME_MAX_CHARS) {
    return ROOM_NAME_MAX_CHARS_MESSAGE
  }

  return ""
}
